import { render, staticRenderFns } from "./KaiCheckbox.vue?vue&type=template&id=24c28f27&scoped=true&"
import script from "./KaiCheckbox.vue?vue&type=script&lang=ts&"
export * from "./KaiCheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c28f27",
  null
  
)

export default component.exports